import { z } from 'zod';
/** `notification_concerns.type`: the source shows CUSTOM only; SYSTEM is reserved. */
export const CONCERN_TYPES = ['CUSTOM', 'SYSTEM'];
export const ConcernTypeSchema = z.enum(CONCERN_TYPES);
/** `notification_templates.channel` (push of the same text if Q-18 confirms). */
export const NOTIFICATION_CHANNELS = ['IN_APP'];
export const NotificationChannelSchema = z.enum(NOTIFICATION_CHANNELS);
/** `bulk_campaigns.collection`: the "Collection" column in the source list. */
export const BULK_COLLECTIONS = ['CUSTOMER'];
export const BulkCollectionSchema = z.enum(BULK_COLLECTIONS);
/** Bulk criteria field whitelist (05-api-specification.md § Criteria engine contract). */
export const CRITERIA_FIELDS = [
    'FIRST_NAME',
    'LAST_NAME',
    'EMAIL',
    'PHONE',
    'CITY',
    'STATE',
    'REFERRER_ID',
    'CUSTOMER_NUMBER',
    'REGISTERED_DATE',
];
export const CriteriaFieldSchema = z.enum(CRITERIA_FIELDS);
/** Bulk criteria condition operator; OR is expressed by groups, not by an operator. */
export const CRITERIA_OPERATORS = ['EQ'];
export const CriteriaOperatorSchema = z.enum(CRITERIA_OPERATORS);
/** `bulk_campaigns.criteriaStatus`. */
export const CRITERIA_STATUSES = ['PENDING', 'PROCESSING', 'COMPLETED', 'FAILED'];
export const CriteriaStatusSchema = z.enum(CRITERIA_STATUSES);
/** `bulk_campaigns.templateStatus`. */
export const TEMPLATE_STATUSES = ['PENDING', 'COMPLETED'];
export const TemplateStatusSchema = z.enum(TEMPLATE_STATUSES);
/** `bulk_campaigns.approvalStatus` (maker-checker, Q-08). */
export const APPROVAL_STATUSES = ['NOT_SUBMITTED', 'PENDING', 'APPROVED', 'REJECTED'];
export const ApprovalStatusSchema = z.enum(APPROVAL_STATUSES);
/** `bulk_campaigns.dispatchStatus`. */
export const DISPATCH_STATUSES = [
    'NOT_STARTED',
    'SCHEDULED',
    'DISPATCHING',
    'SENT',
    'FAILED',
];
export const DispatchStatusSchema = z.enum(DISPATCH_STATUSES);
/** How the admin types a bulk criteria value: free text or a SAST calendar day (`YYYY-MM-DD`). */
export const CRITERIA_VALUE_TYPES = ['TEXT', 'DATE'];
export const CriteriaValueTypeSchema = z.enum(CRITERIA_VALUE_TYPES);
//# sourceMappingURL=notifications.js.map